var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementErrors } from "./reactquestion";
import { SurveyElementBase } from "./reactquestion_element";
import { ReactElementFactory } from "./element-factory";
import { SurveyPanelBase } from "./panel-base";
import { ReactSurveyElementsWrapper } from "./reactsurveymodel";
import { SurveyActionBar } from "./components/action-bar/action-bar";
import { TitleElement } from "./components/title/title-element";
import { SurveyElementHeader } from "./element-header";
var SurveyPanel = /** @class */ (function (_super) {
    __extends(SurveyPanel, _super);
    function SurveyPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.hasBeenExpanded = false;
        return _this;
    }
    Object.defineProperty(SurveyPanel.prototype, "panel", {
        get: function () {
            return this.panelBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyPanel.prototype.renderElement = function () {
        var _this = this;
        var header = this.renderHeader();
        var errors = (React.createElement(SurveyElementErrors, { element: this.panelBase, cssClasses: this.panelBase.cssClasses, creator: this.creator }));
        var style = {
            paddingLeft: this.panel.innerPaddingLeft,
            display: this.panel.renderedIsExpanded ? undefined : "none",
        };
        var content = null;
        if (this.panel.renderedIsExpanded) {
            // this.hasBeenExpanded = true;
            var rows = this.renderRows(this.panelBase.cssClasses);
            var className = this.panelBase.cssClasses.panel.content;
            content = this.renderContent(style, rows, className);
        }
        var focusIn = function () {
            if (_this.panelBase)
                _this.panelBase.focusIn();
        };
        return (React.createElement("div", { ref: this.rootRef, className: this.panelBase.getContainerCss(), onFocus: focusIn, id: this.panelBase.id },
            this.panel.showErrorsAbovePanel ? errors : null,
            header,
            this.panel.showErrorsAbovePanel ? null : errors,
            content));
    };
    SurveyPanel.prototype.renderHeader = function () {
        if (!this.panel.hasTitle && !this.panel.hasDescription) {
            return null;
        }
        return React.createElement(SurveyElementHeader, { element: this.panel });
    };
    SurveyPanel.prototype.wrapElement = function (element) {
        var survey = this.panel.survey;
        var wrapper = null;
        if (survey) {
            wrapper = ReactSurveyElementsWrapper.wrapElement(survey, element, this.panel);
        }
        return wrapper !== null && wrapper !== void 0 ? wrapper : element;
    };
    SurveyPanel.prototype.renderContent = function (style, rows, className) {
        var bottom = this.renderBottom();
        return (React.createElement("div", { style: style, className: className, id: this.panel.contentId, role: this.panel.ariaRole, "aria-labelledby": this.panel.ariaLabelledBy, "aria-label": this.panel.ariaLabel },
            rows,
            bottom));
    };
    SurveyPanel.prototype.renderTitle = function () {
        if (!this.panelBase.title)
            return null;
        return React.createElement(TitleElement, { element: this.panelBase });
    };
    SurveyPanel.prototype.renderDescription = function () {
        if (!this.panelBase.description)
            return null;
        var text = SurveyElementBase.renderLocString(this.panelBase.locDescription);
        return (React.createElement("div", { className: this.panel.cssClasses.panel.description }, text));
    };
    SurveyPanel.prototype.renderBottom = function () {
        var footerToolbar = this.panel.getFooterToolbar();
        if (!footerToolbar.hasActions)
            return null;
        return React.createElement(SurveyActionBar, { model: footerToolbar });
    };
    SurveyPanel.prototype.getIsVisible = function () {
        return this.panelBase.getIsContentVisible();
    };
    return SurveyPanel;
}(SurveyPanelBase));
export { SurveyPanel };
ReactElementFactory.Instance.registerElement("panel", function (props) {
    return React.createElement(SurveyPanel, props);
});
